import { render } from "./QuestDialog8.vue?vue&type=template&id=3077195b"
import script from "./QuestDialog8.vue?vue&type=script&lang=js"
export * from "./QuestDialog8.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog8.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3077195b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3077195b', __exports__)) {
    api.reload('3077195b', __exports__)
  }
  
  module.hot.accept("./QuestDialog8.vue?vue&type=template&id=3077195b", () => {
    api.rerender('3077195b', render)
  })

}


export default __exports__